import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import initialState from '../helpers/form-helpers/initial-state';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import RaMembersSummaryDetailsFormData from '../ra-members/helpers/ra-members-summary-form-data';
import * as signInFormActions from '../../../store/actions/sign-in-form-actions';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';

class RaMembersSummaryForm extends Component {
    constructor(props) {
        super(props);
        const { formData, ssoDomain } = this.props;

        const mainAddress = upgradeFormHelper.getMainAddress(formData.currentUser);

        this.state = {
            ...initialState.upgradeRaMembersFormState,
            [formConstants.country]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.country),
            [formConstants.county]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.county),
            [formConstants.state]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.state),
            [formConstants.city]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.city),
            [formConstants.addressLine1]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine1),
            [formConstants.addressLine2]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine2),
            [formConstants.addressLine3]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine3),
            [formConstants.postcode]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.postcode),
            ssoDomain,
            userDataLoaded:false
        };

        this.formMessageRef = React.createRef();
        this.formReferences = formScrollHelpers.getFormReferences(formData);

        this.displayRaMembersSummaryForm = this.displayRaMembersSummaryForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserUpdateRaMembersSummarySuccess = this.handleUserUpdateRaMembersSummarySuccess.bind(this);
        this.submitRaMembersSummaryData = this.submitRaMembersSummaryData.bind(this);
    }

    componentDidMount() {
        const { onSignIn, formData, actions } = this.props;

        if (isEmpty(formData)) {
            onSignIn();
        }

        const { callBackUrl } = formData;
        actions.getUserAccountData(callBackUrl, false);
    }

    componentWillReceiveProps(nextProps) {
        const {
            formData,
            isUpgradeSuccessful,
            loading,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful,
            isUserAccountDataLoadedSuccessful,
            userAccountData
        } = nextProps;

        const {userDataLoaded} = this.state;

        if (!loading && isUserAddressRetrieveSuccessful && !isUpgradeSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
            return;
        }

        if (!loading &&
            isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserUpdateBallotSummarySuccess);
            return;
        }

        if (!loading &&
            !isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }

        if (!loading && !isEmpty(userAccountData) &&
            isUserAccountDataLoadedSuccessful && !userDataLoaded) {
            this.updateUserAccountData(userAccountData);
        }
    }

    updateUserAccountData(nextUserAccountData) {
        const { formData } = this.props;

        const userAccountData = _.cloneDeep(nextUserAccountData);

        const userDetailsFormData = new RaMembersSummaryDetailsFormData(formData, userAccountData);

        this.setState(formStateHelpers.updateFormFields(userDetailsFormData));

        this.setState(
            (prevState) => ({
                ...prevState,
                userDetailsFormData,
                userDataLoaded:true
            })
        );
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.upgradeAccountFormState);
        actions.resetUpgradeAccountFormState();
    }

    handleUserUpdateRaMembersSummarySuccess() {
        const { actions } = this.props;
        actions.retryPurchase();
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitRaMembersSummaryData);
    }

    submitRaMembersSummaryData() {
        const { actions, formData, userAccountData } = this.props;
        const { callBackUrl } = formData;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.upgradeRaMembersSummaryAccount(this.state, userAccountData, callBackUrl);
        signInFormActions.setRaMembersCookie();
    }

    displayForm() {
        const {
            isUpgradeSuccessful,
            accountUpgradeMessages,
            purchaseAttemptMessages,
            formData
        } = this.props;

        if (isEmpty(formData)) {
            return null;
        }

        const messagesToDisplay = _.isEmpty(accountUpgradeMessages) ? purchaseAttemptMessages : accountUpgradeMessages;

        return (<Fragment>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isUpgradeSuccessful}
                    messages={messagesToDisplay}></FormMessage>
                {this.displayRaMembersSummaryForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitBallotSummaryFormButtonText}
                ></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayRaMembersSummaryForm() {
        const { actions, formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target), this.updateFormData); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target), this.updateFormData); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event), this.updateFormData); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event), this.updateFormData); },
            handleRaMemberIdChange: (event) => { this.setState(formStateHelpers.handleRaMemberIdChange(event), this.updateFormData); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),);
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, formData } = this.props;
        const { formBanner } = formData;
        return (
            <div className='modal__content form-container'>
                <div className='constrain-tablet ff-founders fs-14'>
                    <RegisterFormBanner
                        formBanner={formBanner}></RegisterFormBanner>
                    <section className='form-popup__content'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </section>
                </div>
            </div>
        );
    }
}

RaMembersSummaryForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    ssoDomain: PropTypes.string,
    formData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        formData: _.isEmpty(ownProps.formData) ? state.registerForm.formData : ownProps.formData,
        isUpgradeSuccessful: state.upgradeAccountForm.isUpgradeSuccessful,
        accountUpgradeMessages: state.upgradeAccountForm.accountUpgradeMessages,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress,
        userAccountData: state.userAccount.userAccountData,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            upgradeRaMembersSummaryAccount: bindActionCreators(upgradeAccountActions.upgradeRaMembersSummaryAccount, dispatch),
            resetUpgradeAccountFormState: bindActionCreators(upgradeAccountActions.resetUpgradeAccountFormState, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch),
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RaMembersSummaryForm);
